export default __webpack_public_path__ + "static/website-development-23976a3abfac5b6d0107474f3374d5ca.webp";